<div class="page">
  <div class="header-page">
    <div class="title">
      Langues
    </div>
    <div class="search">
      Barre de recherche
    </div>
  </div>
  <div class="contenu-page">
    <div class="first-el">
      Vous pouvez gérer ici les langues disponibles dans votre application. Une fois la langue ajoutée, vous pourrez traduire vos circuits.
      <br>
      La langue par défaut est la langue utilisée par tous les appareils non reconnu ou avec une langue non gérée.
      <br>
      Attention, si un contenu n'est pas disponible dans une langue, il ne sera pas disponible pour les utilisateurs de cette langue.
    </div>
    <div class="langs">
      <div class="single-lang">
        
      </div>
    </div>
  </div>
</div>
